<template>
	<v-dialog
			v-model="visible"
			v-bind="$attrs"
			v-on="$listeners"
			fullscreen
			no-click-animation
			:retain-focus="false"
			ref="dialog"
	>
		<v-app-bar dark color="primary" dense>
			<v-spacer></v-spacer>
			<v-toolbar-title>
				<v-img
						:src="$buildBrandedAssetsURL('/logos/white_long.png')"
						:lazy-src="$buildBrandedAssetsURL('/logos/white_long.png')"
						contain
						width="200"
				/>
			</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-app-bar>

		<v-card class="fill-height">
			<v-card-text class="fill-height">
				<v-container fluid class="fill-height">
					<v-row no-gutters align="center" justify="center">
						<v-col cols="12" class="text-center">
							<v-icon color="accent" :size="100">mdi-lock-alert</v-icon>
							<Title bold>Automatiskt utloggad</Title>
							<Title small>Du har blivit automatiskt utloggad p.g.a inaktivitet</Title>
							<Title small>Du kan när som helst ändra dina inställningar för inaktivitet under dina preferenser</Title>

							<v-btn color="primary" depressed class="mt-4" @click="visible = false">Jag förstår</v-btn>
						</v-col>

						<v-col cols="12" class="text-center mt-5 pt-5">
							<Title bold>Var hittar jag mina preferenser?</Title>
							<Title small>Efter att du har loggat in så klickar du på ditt namn uppe i högra hörnet</Title>

							<img
									class="mt-2"
									:src="require('@/assets/img/preferences.png')"
									:lazy-src="require('@/assets/img/preferences.png')"
									width="253"
							/>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import Dialog from './Dialog.vue';
import Title  from './typography/Title.vue';

export default {
	name: 'LoggedOutDueToInactivityDialog',

	data: () => ({
		visible: false,
	}),

	methods: {
		show() {
			this.visible = true;
		},
	},

	components: {Title, Dialog},
}
</script>

<style scoped>

</style>
